import React from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ACTIONS from '../redux/actions/Page';

// import { Block } from "../components";
import ProjectView from '../components/Project';

function mapStateToProps(state) {
  return {
    entry: state.Page.entry,
    article: state.Page.article,
    loading: state.Page.loading,
    loaded: state.Page.loaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchPage: bindActionCreators(ACTIONS.getPage, dispatch),
    fetchArticle: bindActionCreators(ACTIONS.getArticle, dispatch),
    clearArticle: bindActionCreators(ACTIONS.clearArticle, dispatch),
  };
}

class Project extends React.Component {
  componentDidMount() {
    this.props.fetchArticle(this.props.location.pathname);
    window.scrollTo(0, 0);
  }

  render() {
    let { article, loading } = this.props;

    console.log('Project article', article);

    if (article && article.type !== 'projects') return null;

    return <ProjectView entry={article} loading={loading} />;

    // if (!article) return null;

    // let gridItems = article.blocks.map((item, ix) => {
    //   return (
    //     <div
    //       key={ix}
    //       className={"Template-gridItem  Template-gridItem--" + item.style}
    //     >
    //       <Block block={item} />
    //     </div>
    //   );
    // });

    // let informationItems = article.information.map((i, ix) => {
    //   return (
    //     <li key={ix} className="List-item">
    //       <span>{i.title}: </span>
    //       <span>{i.text}</span>
    //     </li>
    //   );
    // });

    // let style = null;

    // if (article.backgroundColour) {
    //   style = {
    //     backgroundColor: article.backgroundColour,
    //   };
    // }

    // return (
    //   <div className={"Template Template--" + article.template} style={style}>
    //     <div className="Template-head">
    //       {" "}
    //       <h1> {article.title}</h1>
    //     </div>

    //     <div className="Template-intro">
    //       <h1> {article.intro} </h1>
    //     </div>

    //     <div className="Template-grid">{gridItems}</div>

    //     <div className="Template-foot">
    //       <ul className="List  List--information">{informationItems}</ul>
    //     </div>
    //   </div>
    // );
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Project),
);



// WEBPACK FOOTER //
// ./src/js/templates/project.js